import FieldsPayStubStart from './FieldsPayStubStart'

export default FieldsPayStubStart
